import { render } from "./IconGood.vue?vue&type=template&id=778ec47e"
import script from "./IconGood.vue?vue&type=script&lang=js"
export * from "./IconGood.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__